module.exports = __webpack_public_path__ + "prod/1.42.2/img/renshi-four.1f03e242.png";